import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'order-status-history',
  templateUrl: './order-status-history.component.html',
  styleUrls: ['./order-status-history.component.scss']
})
export class OrderStatusHistoryComponent implements OnInit {
	@Input() order;
  possibleStatuses: any;
  statuses: any;
  endStatuses: string[] = ['completed', 'rejected', 'canceled', 'declined', 'delivery_ended', 'converted_to_invoice', 'delivered'];

  constructor() { }

  ngOnInit(): void {
    this.possibleStatuses = this.order?.possible_statuses;
    this.statuses = this.order?.statuses;
  }

  getStatusesToDisplay(): string[] {

    // Check if 'canceled' or 'declined' is present in the statuses
    const hasCanceledOrDeclined = this.statuses.some(item => item.status === 'canceled' || item.status === 'declined' || item.status === 'rejected' || item.status === 'expired');

    // Determine the index of the last possible status to display before 'canceled' or 'declined'
    const lastPossibleIndex = this.possibleStatuses.findIndex(status =>
      this.statuses.some(item => item.status === status)
    );
    
    if (hasCanceledOrDeclined) {
      // Show statuses up to and including the last status present in `statuses`, and then add 'canceled' or 'declined'
      const statusesToShow = this.possibleStatuses.slice(0, lastPossibleIndex + 1);
      
      if (this.statuses.some(item => item.status === 'canceled')) {
        statusesToShow.push('canceled');
      }
      if (this.statuses.some(item => item.status === 'declined')) {
        statusesToShow.push('declined');
      }
      if (this.statuses.some(item => item.status === 'rejected')) {
        statusesToShow.push('rejected');
      }
      if (this.statuses.some(item => item.status === 'expired')) {
        statusesToShow.push('expired');
      }
      return statusesToShow;
    } else {
      // Otherwise, show all possible statuses
      return this.possibleStatuses;
    }
  }

  // Get the date and time for a given status
  getDateTime(status: string): string | null {
    const item = this.statuses.find(item => item.status === status);
    return item ? item.created_at : null;
  }
}
